import React, { Component } from 'react'
import { connect } from 'react-redux'
import { number } from 'prop-types'
import ReactPaginate from 'react-paginate'
import { bindActionCreators } from 'redux'
import AdoptionMiddleware from './../modules/adoption/middleware'

const mapStateToProps = ({ adoption }) => ({
  pageCount: adoption.paginate.pageCount,
  perPage: adoption.paginate.perPage,
  page: adoption.paginate.page
})

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({
    changePageAdoption: (params) => AdoptionMiddleware.changePageAdoption(params)
  }, dispatch)
}

class PaginationContainer extends Component {
  static propsTypes = {
    pageCount: number
  }

  handlePageClick = (data) => {
    const selected = data.selected
    const page = selected + 1
    const { changePageAdoption } = this.props
    changePageAdoption(page)
  }

  render () {
    return (
      <div className='container'>
        {this.props.pageCount > 1 &&
          <nav className='pagination is-small is-centered'>
            <ReactPaginate
              previousLabel={'❮'}
              nextLabel={'❯'}
              previousClassName={'page-previous'}
              nextClassName={'page-next'}
              breakLabel={<a href=''>...</a>}
              breakClassName={'pagination-ellipsis'}
              pageCount={this.props.pageCount}
              marginPagesDisplayed={2}
              pageRangeDisplayed={5}
              pageLinkClassName={'pagination-link'}
              onPageChange={this.handlePageClick}
              containerClassName={'pagination-list'}
              subContainerClassName={'pages'}
              activeClassName={'is-current'}
            />
          </nav>
        }
      </div>
    )
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(PaginationContainer)



// WEBPACK FOOTER //
// ./src/containers/PaginationContainer.js